import { isDevelopingApp, macroCondition } from "@embroider/macros";
import { getStore } from './-utils';
import { Graph, Graphs } from './graph';
function isStore(maybeStore) {
  return maybeStore._instanceCache !== undefined;
}
function getWrapper(store) {
  return isStore(store) ? store._instanceCache._storeWrapper : store;
}
export function peekGraph(store) {
  return Graphs.get(getWrapper(store));
}
export function graphFor(store) {
  const wrapper = getWrapper(store);
  let graph = Graphs.get(wrapper);
  if (!graph) {
    graph = new Graph(wrapper);
    Graphs.set(wrapper, graph);

    // in DEBUG we attach the graph to the main store for improved debuggability
    if (macroCondition(isDevelopingApp())) {
      if (getStore(wrapper).isDestroying) {
        throw new Error(`Memory Leak Detected During Teardown`);
      }
      Graphs.set(getStore(wrapper), graph);
    }
  }
  return graph;
}